import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Wards} from './wards.model';
import * as WardsActions from './wards.actions';

export const wardsesFeatureKey = 'wardses';

export interface State extends EntityState<Wards> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Wards> = createEntityAdapter<Wards>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(WardsActions.addWards,
    (state, action) => adapter.addOne(action.wards, state)
  ),
  on(WardsActions.upsertWards,
    (state, action) => adapter.upsertOne(action.wards, state)
  ),
  on(WardsActions.addWardss,
    (state, action) => adapter.addMany(action.wardss, state)
  ),
  on(WardsActions.upsertWardss,
    (state, action) => adapter.upsertMany(action.wardss, state)
  ),
  on(WardsActions.updateWards,
    (state, action) => adapter.updateOne(action.wards, state)
  ),
  on(WardsActions.updateWardss,
    (state, action) => adapter.updateMany(action.wardss, state)
  ),
  on(WardsActions.deleteWards,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(WardsActions.deleteWardss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(WardsActions.loadWardss,
    (state, action) => adapter.setAll(action.wardss, state)
  ),
  on(WardsActions.clearWardss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
